import { forwardRef } from 'react'
import { cn } from '../../lib/cn.js'

/**
 * Square, bordered icon button used for the panel header (close,
 * minimize) and the input row (send). Ships its own focus ring so it
 * stays legible on top of customer-page backgrounds we can't control.
 */
const IconButton = forwardRef(
  ({ className, type = 'button', children, ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex h-9 w-9 items-center justify-center rounded-full',
        'text-[var(--color-surface-foreground)] transition-colors',
        'hover:bg-[var(--color-muted)]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-brand)]',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  ),
)
IconButton.displayName = 'IconButton'

export { IconButton }
